import WaterBanner from "../banners/waterbanner.jpg";
import {
  FaStar,
  FaWhatsapp,
  FaEnvelope,
  FaUsers,
  FaClock,
} from "react-icons/fa";
import { GiCompass } from "react-icons/gi";
import SEO from "../components/common/SEO";
import NavFilters from "../components/common/NavFilters";
import { getBreadcrumbSchema } from "../utils/structuredData";

const tours = [
  {
    id: "secret-beach-escape",
    image: `${process.env.PUBLIC_URL}/images/speedboat/secretbeach (7).jpeg`,
    name: "Secret Beach Escape",
    description:
      "A premium experience to hidden beaches, perfect for relaxing, swimming, and enjoying untouched nature along the stunning Albanian Riviera. Discover secluded coves and pristine shores unreachable by land.",
    price: "100",
    priceLabel: "per person",
    capacity: "4–11 persons",
    duration: "4 hours",
    rating: 5.0,
    number_of_reviews: 39,
    included: [
      "Private skipper",
      "Life jackets",
      "Fuel",
      "Scenic coastal route",
      "Swimming stops at hidden beaches",
    ],
    badge: "Premium Tour",
    whatsappMsg:
      "Hello%2C%20I'd%20like%20to%20request%20the%20Secret%20Beach%20Escape%20in%20Durr%C3%ABs.%20%E2%82%AC100%20per%20person%2C%205%20hours.",
    emailSubject: "Secret%20Beach%20Escape%20Request",
  },
  {
    id: "group-water-sports-tour",
    image: `${process.env.PUBLIC_URL}/twoboatstour.png`,
    name: "Boats • Water Sports • Snorkeling • Up to 20 Guests",
    description:
      "The ultimate group experience on the Adriatic coast. Enjoy an action-packed adventure with speedboat rides, water sports, and snorkeling in crystal-clear Albanian waters. Perfect for groups, celebrations, and corporate events. One complimentary drink included per person.",
    price: "2,300",
    priceLabel: "total",
    capacity: "15–20 persons",
    duration: "4–5 hours",
    rating: 5.0,
    number_of_reviews: 48,
    included: [
      "1 drink per person",
      "Snorkeling equipment",
      "Water Sport equipment",
      "Skipper",
      "Life jackets",
      "Fuel",
    ],
    badge: "Group Tour",
    whatsappMsg:
      "Hello%2C%20I'd%20like%20to%20request%20the%20Group%20Water%20Sports%20%26%20Snorkeling%20Tour%20(up%20to%2020%20guests)%20in%20Durr%C3%ABs.%20Price%3A%20%E2%82%AC2%2C300%20total%2C%204%E2%80%935%20hours.",
    emailSubject: "Group%20Water%20Sports%20%26%20Snorkeling%20Tour%20Request",
  },
  {
    id: "relaxing-private-tour",
    name: "Relaxing Private Cruise",
    image: `${process.env.PUBLIC_URL}/images/speedboat/quicksilver6.jpeg`,
    description:
      "Enjoy a peaceful private cruise along the stunning Albanian Riviera. Perfect for couples and small groups. Bottle of prosecco included. Personalized service and flexible itinerary.",
    price: "350",
    priceLabel: "1\u20133 persons",
    capacity: "1\u20133 persons",
    duration: "90 minutes",
    rating: 5.0,
    number_of_reviews: 62,
    included: [
      "Private skipper",
      "Life jackets",
      "Fuel",
      "Scenic coastal route",
      "Bottle of Prosecco",
    ],
    badge: "Private Tour",
    whatsappMsg:
      "Hello%2C%20I'd%20like%20to%20request%20the%20Relaxing%20Private%20Tour%20in%20Durr%C3%ABs.%20%E2%82%AC350%20for%201%E2%80%933%20persons%2C%2090%20minutes.",
    emailSubject: "Relaxing%20Private%20Tour%20Request",
  },
];

const UniqueTours = () => {
  const breadcrumbs = [
    { name: "Home", path: "/" },
    { name: "Unique Tours", path: "/unique-tours" },
  ];

  const structuredData = getBreadcrumbSchema(breadcrumbs);

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <SEO
        title="Secret Beach Escape & Unique Boat Tours Durrës Albania – SeaPulse"
        description="Discover one-of-a-kind boat tours in Durrës, Albania. Secret Beach Escape to hidden Albanian coves (€100/person), relaxing private cruises (€120/person), and epic group water sports adventures. Request your custom sea experience today."
        keywords="secret beach tour Albania, hidden beach boat tour Durrës, private boat tour Albania, unique boat tours Durrës, relaxing boat cruise Albania, group water sports Albania, snorkeling tour Durrës, private sea tour Albania, exclusive boat tour Albania, hidden cove tour Albania, beach escape Albania, custom boat tour Durrës, Albanian Riviera private tour"
        canonical="/unique-tours"
        structuredData={structuredData}
      />

      {/* Hero Banner */}
      <div className="relative h-[450px] md:h-[500px] lg:h-[550px] flex items-center justify-center overflow-hidden">
        <img
          src={WaterBanner}
          alt="Unique Tours"
          className="absolute inset-0 w-full h-full object-cover brightness-90 dark:brightness-75"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/70 via-cyan-800/60 to-blue-600/50" />
        <div className="relative z-10 flex flex-col items-center justify-center text-center px-4 max-w-5xl mx-auto">
          <span className="inline-block bg-white/20 backdrop-blur-sm text-white text-sm font-semibold px-5 py-2 rounded-full mb-6 border border-white/30 flex items-center gap-2">
            <GiCompass className="text-xl" /> Unique Tours
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-white drop-shadow-2xl mb-6 leading-tight">
            Unique Tour Experiences
          </h1>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/95 max-w-3xl leading-relaxed drop-shadow-lg mb-8">
            Curated one-of-a-kind adventures on the Albanian Adriatic coast —
            group thrills or private serenity, your choice
          </p>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-3 text-white/90 text-xs sm:text-sm">
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
              <span>⭐</span>
              <span className="font-semibold">5.0 Rating</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
              <span>🛡️</span>
              <span className="font-semibold">Licensed & Insured</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
              <span>🎖️</span>
              <span className="font-semibold">Expert Captains</span>
            </div>
          </div>
        </div>
      </div>

      <NavFilters />

      {/* Tours Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent mb-4">
            Available Unique Tours
          </h2>
          <p className="text-base sm:text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto leading-relaxed">
            Request-only experiences crafted for those who want something truly
            special along the Albanian coast
          </p>
        </div>

        <div className="flex flex-col gap-6">
          {tours.map((tour) => (
            <div
              key={tour.id}
              className="group bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-md hover:shadow-2xl transition-all duration-500 overflow-hidden hover:border-cyan-400 dark:hover:border-cyan-500 hover:-translate-y-1"
            >
              <div className="flex flex-col lg:flex-row">
                {/* Image */}
                <div className="relative w-full lg:w-80 h-64 lg:h-72 flex-shrink-0 overflow-hidden">
                  <img
                    src={tour.image}
                    alt={tour.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                  <div className="absolute top-4 left-4 bg-gradient-to-r from-cyan-500 to-blue-600 text-white text-sm font-bold px-4 py-2 rounded-full shadow-xl">
                    ✨ {tour.badge}
                  </div>
                </div>

                {/* Content Section */}
                <div className="flex-1 p-6 lg:p-8 flex flex-col">
                  <div className="flex-1">
                    <h3 className="text-xl lg:text-2xl font-bold text-gray-900 dark:text-white mb-3 group-hover:text-cyan-600 dark:group-hover:text-cyan-400 transition-colors duration-300">
                      {tour.name}
                    </h3>
                    <p className="text-base text-gray-600 dark:text-gray-300 mb-5 leading-relaxed">
                      {tour.description}
                    </p>

                    {/* Stats Row */}
                    <div className="flex flex-wrap items-center gap-3 mb-4">
                      <div className="flex items-center gap-2 bg-yellow-50 dark:bg-yellow-900/20 px-3 py-2 rounded-lg">
                        <FaStar className="text-yellow-500" />
                        <span className="font-bold text-gray-900 dark:text-white">
                          {tour.rating}
                        </span>
                        <span className="text-sm text-gray-600 dark:text-gray-400">
                          ({tour.number_of_reviews} reviews)
                        </span>
                      </div>
                      <div className="flex items-center gap-2 bg-blue-50 dark:bg-blue-900/20 px-3 py-2 rounded-lg text-blue-700 dark:text-blue-300">
                        <FaClock />
                        <span className="font-medium text-sm">
                          {tour.duration}
                        </span>
                      </div>
                      <div className="flex items-center gap-2 bg-cyan-50 dark:bg-cyan-900/20 px-3 py-2 rounded-lg text-cyan-700 dark:text-cyan-300">
                        <FaUsers />
                        <span className="font-medium text-sm">
                          {tour.capacity}
                        </span>
                      </div>
                    </div>

                    {/* Included */}
                    <div className="flex flex-wrap gap-2 mb-2">
                      {tour.included.map((item) => (
                        <span
                          key={item}
                          className="inline-flex items-center gap-1 text-xs bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-400 px-3 py-1 rounded-full border border-green-200 dark:border-green-800 font-medium"
                        >
                          ✓ {item}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Price & Action Section */}
                  <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-5 border-t border-gray-200 dark:border-gray-700 mt-4">
                    <div>
                      <span className="text-sm text-gray-500 dark:text-gray-400 block mb-1 font-medium">
                        Price
                      </span>
                      <div className="text-4xl font-extrabold bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent">
                        €{tour.price}
                      </div>
                      <span className="text-sm text-gray-500 dark:text-gray-400">
                        {tour.priceLabel}
                      </span>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
                      <a
                        href={`https://wa.me/355692311606?text=${tour.whatsappMsg}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full sm:w-auto"
                      >
                        <button className="w-full sm:w-auto flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white font-bold px-6 py-4 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl group-hover:scale-105 text-base">
                          <FaWhatsapp className="text-xl" /> Request via
                          WhatsApp
                        </button>
                      </a>
                      <a
                        href={`mailto:seapulsealbania@gmail.com?subject=${tour.emailSubject}`}
                        className="w-full sm:w-auto"
                      >
                        <button className="w-full sm:w-auto flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold px-6 py-4 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl group-hover:scale-105 text-base">
                          <FaEnvelope className="text-xl" /> Email Us
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UniqueTours;
